"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalvertLogo = exports.MonarchLogo = exports.DefaultLogo = exports.CalvertLogoArgs = exports.MonarchLogoArgs = exports.DefaultLogoArgs = void 0;
var il_logo_1 = require("./il-logo");
var get_component_1 = require("../../shared/helpers/get-component");
var enums_1 = require("../../shared/enums");
// args
exports.DefaultLogoArgs = {};
exports.MonarchLogoArgs = {
    logo: enums_1.LogoEnum.MONARCH,
    alt: 'monarch logo',
};
exports.CalvertLogoArgs = {
    logo: enums_1.LogoEnum.CALVERT,
    alt: 'calvert logo',
};
// common components
exports.DefaultLogo = (0, get_component_1.getComponent)(il_logo_1.ILLogo, exports.DefaultLogoArgs);
exports.MonarchLogo = (0, get_component_1.getComponent)(il_logo_1.ILLogo, exports.MonarchLogoArgs);
exports.CalvertLogo = (0, get_component_1.getComponent)(il_logo_1.ILLogo, exports.CalvertLogoArgs);
